import React, { useMemo } from 'react';

import {
  DEFAULT_THEME,
  type ThemeName,
  themes,
} from '~/design-tokens/themes/themes';

const ROOT_Z_INDEX_TOKENS = [
  '--z-index-smarttable-sticky-header-cell: 1;',
  '--z-tooltip: 22;',
  '--z-index-modal: 15;',
].join('\n  ');

const buildRootThemeCss = (themeName: ThemeName) => {
  const themeTokens = themes[themeName] ?? themes[DEFAULT_THEME];
  const cssVariables = Object.entries(themeTokens)
    .map(([token, value]) => `${token}: ${value};`)
    .join('\n  ');

  return `:root {\n  ${cssVariables}\n  ${ROOT_Z_INDEX_TOKENS}\n}`;
};

export interface ThemeGlobalStylesProps {
  $themeName?: ThemeName;
}

export const ThemeGlobalStyles = ({ $themeName }: ThemeGlobalStylesProps) => {
  const css = useMemo(
    () => buildRootThemeCss($themeName ?? DEFAULT_THEME),
    [$themeName]
  );

  return <style>{css}</style>;
};
